import OverallExpense from "../../../../components/company/expense/overall-expense";

export default function OverallExpensePage() {
    return <OverallExpense/>;
}